import { useProviderServices } from './use-provider-services';

export const useServicesByProviderId = (providerId) => {
  return useProviderServices().filter((provService) => provService.labelProviderId === providerId);
};
